// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"a51a085c6e3490a9f105","678":"b9571b7d2fe6783f59ea","883":"473ad20e03664d650275"}[chunkId] + ".js";
};